import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../config/Translate";
import AppAnimate from "../../components/AppAnimate";
import Grid from "@material-ui/core/Grid/Grid";
import MakeYourFirstProduct from "./components/MakeYourFirstProduct";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {Link} from "react-router-dom";
import {connect} from "trim-redux";
import Alert from "@material-ui/lab/Alert/Alert";
import Button from "@material-ui/core/Button/Button";
import FileCopyRoundedIcon from "@material-ui/icons/FileCopyRounded";
import MarketerGuidLine from "./user_components/MarketerGuidLine";
import MarketerToDos from "./user_components/MarketerToDos";


class MarketerDashboard extends React.Component {
    classes = this.props.classes;
    handleCopy(content){
        navigator.clipboard.writeText(content);
        this.props.enqueueSnackbar(Translate.marketerIdCopied, {
            variant: 'info',
        });
    }
    render(){
        let {user} = this.props;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.dashboard}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12}>
                        <Alert severity="info" variant="outlined"
                               action={
                                   <Button
                                       color="secondary"
                                       size="small"
                                       variant="contained"
                                       endIcon={<FileCopyRoundedIcon/>}
                                       onClick={() => this.handleCopy(user.marketer_id)}
                                       style={{color:'#fff',whiteSpace:"nowrap"}}
                                   >
                                       {user.marketer_id}
                                   </Button>
                               }
                        >
                            {Translate.welcomeToMarketerDashboard}
                        </Alert>
                    </Grid>
                    <Grid item xs={12}>
                        <MarketerGuidLine/>
                    </Grid>
                    <Grid item xs={12}>
                        <MarketerToDos/>
                    </Grid>
                </Grid>
            </AppAnimate>
        );
    }
}

const mstp = state => ({
    user: state.user,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(MarketerDashboard)))));
